export default {
    Default: 2500
}